import React, { Fragment, useEffect, useState } from "react";
import { Dropdown, Menu, Badge, Popover, Collapse } from "antd";
import APIService from "../services/APIService";
import { selectCountCart, setModalCart } from "../app/features/cart";
import { useSelector, useDispatch } from "react-redux";
import {
  CaretDownOutlined,
  QuestionCircleOutlined,
  PhoneOutlined,
  SearchOutlined,
  UserOutlined,
  HeartOutlined,
  ShoppingCartOutlined,
  TagFilled,
  ShopFilled,
  InfoCircleFilled,
  StarFilled,
  MenuOutlined,
} from "@ant-design/icons";
import { images } from "../assets";
import { Link, NavLink, useLocation } from "react-router-dom";
import {
  selectToken,
  clearAuthen,
  selectUsername,
  selectTypeUser,
  selectAuthen,
} from "../app/features/authen";
import SearchBar from "./SearchBar";
import TopBanner from "./home/TopBanner";
import { saveCookies } from "../utils";
const { Panel } = Collapse;

export default function Header() {
  const location = useLocation();
  const [listCategory, setListCategory] = useState(["", "", "", "", ""]);
  const [banner, setBanner] = useState({});
  const [hoverProduct, setHoverProduct] = useState(false);
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const userName = useSelector(selectUsername);
  const typeUser = useSelector(selectTypeUser);
  const countCart = useSelector(selectCountCart);
  const authen = useSelector(selectAuthen);
  const onOpen = () => {
    dispatch(setModalCart(true));
  };
  const menuInfo = (
    <Menu
      items={[
        {
          key: "1",
          label: token ? (
            <button
            onClick={async() => {
              const objAuthen = {
                drug_store: authen.drug_store,
                token: authen.token,
                userinfo: authen.userinfo
              }
              await saveCookies(JSON.stringify(objAuthen))
              window.open(`${typeUser == "GDP" ? 'https://gdp-staging.sphacy.vn/' : 'https://gpp-staging.sphacy.vn/'}`, '_blank', 'noopener,noreferrer');
            }}
            target={`_blank`}
            class=" py-3 px-0  flex justify-center menu w-full text-base font-bold"
          >
            HỆ THỐNG QUẢN LÝ
          </button>
          ) : (
            ""
          ),
        },
        {
          key: "2",
          label: token ? (
            <button
              onClick={() => {
                dispatch(clearAuthen());
              }}
              target={token && `_blank`}
              class=" py-3 px-0  flex justify-center menu w-full text-base font-bold"
            >
              ĐĂNG XUẤT
            </button>
          ) : (
            ""
          ),
        },
      ]}
    />
  );

  const renderRowMenu = (row) => {
    if (row.children) {
      return (
        <Collapse
          bordered={false}
          expandIconPosition="end"
          className="site-collapse-custom-collapse"
        >
          <Panel
            header={row.name}
            key="1"
            className="text-[#222222] site-collapse-custom-panel"
          >
            {row.children.map((item) => (
              <p className="py-3 text-left-menu">{item.name}</p>
            ))}
          </Panel>
        </Collapse>
      );
    } else {
      return (
        <Link to={`/category?cateId=${row.id}`} onClick={() => setHoverProduct(false)}>
          <p className="px-3 py-2 hover:bg-[#ffffff] hover:text-[#119AE2] text-[#222222] font-normal hover:font-extrabold">
            {row.name}
          </p>
        </Link>
      );
    }
  };

  async function getListCategory() {
    const RESULT = await APIService.getListCategory();
    if (RESULT) {
      setListCategory(RESULT);
    }
  }

  useEffect(() => {
    getListCategory();
  }, []);
  async function getListBanner(from) {
    const RESULT = await APIService.getListBanner(from);
    if (RESULT) {
      setBanner(RESULT);
    }
  }

  useEffect(() => {
    getListBanner("according-drug");
  }, []);
  const content = (
    <div className="flex flex-row w-content h-[405px] ">
      <div className="p-2 rounded-[10px] w-[250px] overflow-scroll">
        {listCategory.map((item) => renderRowMenu(item))}
      </div>
      <div className="flex flex-1 p-3 bg-white">
        <TopBanner data={banner.above} />
      </div>
    </div>
  );
  const dropContent = (
    <a
      className="flex items-center "
      href=""
      onClick={(e) => e.preventDefault()}
    >
      {/* <div className="font-bold text-[#119AE2] sm:text-xs text-[8px] mr-2 flex flex-col items-end">
        <p>Hi,</p>
        {userName || "Khách"}
      </div> */}
      {!token ? (
        <Link to="/signin">
          <div className="w-[36px] h-[36px] border-blue-600 rounded-full flex items-center">
            <UserOutlined style={{ width: "35px" }} />
          </div>
        </Link>
      ) : (
        <div className="w-[36px] h-[36px] border-blue-600 rounded-full flex items-center">
          <UserOutlined style={{ width: "35px" }} />
        </div>
      )}
    </a>
  );
  return (
    <div className="flex flex-col md:hidden block">
      <div className="flex flex-col items-center px-4 pb-4">
        <div className="flex flex-1 items-center my-5 w-full">
          <div className="flex flex-1 items-center justify-start">
            <MenuOutlined className="text-lg" />
          </div>
          <Link to="/" className="flex flex-1 items-center justify-center">
            <div>
              <div className="bg-white w-[37px] h-[37px] border overflow-hidden border-main-blue rounded-full">
                <img alt="logo" src={images.logo} />
              </div>
            </div>
            <img
              alt="branch"
              src={images.branch}
              className="h-[14px] ml-[8px]"
            />
          </Link>
          <div className="flex flex-1 items-center justify-end">
            {countCart > 0 && (
              <Badge count={countCart} color="#119AE2">
                <button
                  className="bg-gray  w-[36px] h-[36px] p-3 rounded-full flex justify-center ml-7"
                  onClick={onOpen}
                >
                  <ShoppingCartOutlined />
                </button>
              </Badge>
            )}
          </div>
        </div>
        <SearchBar />
      </div>
    </div>
  );
}
//flex items-center ml-6 text-base
